$(document).ready(function () {
  // modal okna
  if ($('.modal').length) {
    modal();
    // modal okna
  }

  // redirect from thx page
  if ($('#homepage-url').length) {
    thankYouPage();
  }

  // scroll to anchor (source: https://jonsuh.com/blog/better-scroll-to-anchor-links/)
  $('a.js-scroll').click(function (e) {
    e.preventDefault();
    anchorScroll($(this), $($(this).attr('href')), 200);
  });

  var path = window.location.href;
  if (path.indexOf('#mortgageExample') >= 0) {
    anchorScroll($('a.js-scroll'), $('#mortgageExample'), 200);
  }
  if (path.indexOf('#faq') >= 0) {
    anchorScroll($('a.js-scroll'), $('#faq'), 200);
  }

  function anchorScroll(this_obj, that_obj, base_speed) {
    var this_offset = this_obj.offset();
    var that_offset = that_obj.offset();
    var offset_diff = Math.abs(that_offset.top - this_offset.top);

    var speed = (offset_diff * base_speed) / 1000;

    var offset_scroll = 20;

    if (window.innerWidth > 976) {
      offset_scroll = 160;
    }

    $('html,body').animate(
      {
        scrollTop: that_offset.top - offset_scroll,
      },
      speed
    );
  }
});

function toggleMenu() {
  document.getElementById('header').classList.toggle('c-header--opened');
}

function closeMenu() {
  document.getElementById('header').classList.remove('c-header--opened');
}

function openModal() {
  document
    .getElementById('pageBlocker')
    .classList.add('u-page_blocker--opened');
  document
    .getElementById('compareOptionsModal')
    .classList.add('c-modal_default--opened');
  document
    .getElementById('closeModal')
    .classList.add('c-modal_default__close_button--opened');
  disableScroll();
}
function openModalMortgageDetailInfo(elem) {
  $('#modal-bank-name').text($(elem).data('bank-name'));
  $('#modal-product-name').text($(elem).data('product-name'));
  $('#modal-interest-rate').text($(elem).data('interest-rate'));
  $('#modal-rpsn').text($(elem).data('rpsn'));
  $('#modal-payment').text($(elem).data('payment'));
  $('.modal-bank-logo').hide();
  $('#logo-' + $(elem).data('bank-code')).show();
  $('#mortgage_bank_selection_apiSelectedOffer').val($(elem).data('id'));
  $('#button-select-offer').click();
}
function hideModal() {
  document
    .getElementById('pageBlocker')
    .classList.remove('u-page_blocker--opened');
  document
    .getElementById('compareOptionsModal')
    .classList.remove('c-modal_default--opened');
  document
    .getElementById('closeModal')
    .classList.remove('c-modal_default__close_button--opened');
  enableScroll();
}

function disableScroll() {
  // Get the current page scroll position
  scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  // if any scroll is attempted, set this to the previous value
  window.onscroll = function () {
    window.scrollTo({ left: scrollLeft, top: scrollTop });
  };
}

function enableScroll() {
  window.onscroll = function () {};
}
function menuBackground() {
  if (window.innerWidth > 976) {
    if (window.pageYOffset > 20) {
      document.getElementById('header').style.backgroundColor = '#fff';
      document.getElementById('header').style.boxShadow =
        '0px 0px 20px rgba(0,0,0,0.1)';
    } else {
      document.getElementById('header').style.backgroundColor = 'transparent';
      document.getElementById('header').style.boxShadow = 'unset';
    }
  } else {
    if (window.pageYOffset > 20) {
      document.getElementById('mobileBar').style.backgroundColor = '#fff';
      document.getElementById('mobileBar').style.boxShadow =
        '0px 0px 20px rgba(0,0,0,0.1)';
    } else {
      document.getElementById('mobileBar').style.backgroundColor =
        'transparent';
      document.getElementById('mobileBar').style.boxShadow = 'unset';
    }
  }
}
window.addEventListener('scroll', function () {
  menuBackground();
});
menuBackground();
